import React, { Component } from 'react';
import SignupForm from './signupForm';
import VerifyEmail from './verifyEmail';
import VerifyPhone from './verifyPhone';
import Error from '../Error/error';

const PAGE_FORM           = 1;
const PAGE_VERIFY_EMAIL   = 2;
const PAGE_VERIFY_PHONE   = 3;

export default class Signup extends Component
{
    constructor(props)
    {
        super(props);

        this.state =
        {
            page: props.isPostLoginVerification ? (this.props.verifyPostLoginEmail ? PAGE_VERIFY_EMAIL : PAGE_VERIFY_PHONE) : PAGE_FORM,
            user: null
        }
    }
    componentDidMount()
    {
        // this.setState({ page: PAGE_VERIFY_EMAIL })
    }

    render()
    {
        const formPage = <SignupForm
                            closeCard={() => { this.closeCard() }}
                            onAccountCreated={this.onAccountCreated.bind(this)}
                        >
                        </SignupForm>;

        const verifyEmailPage = <VerifyEmail
                                    user={(this.props.isPostLoginVerification) ? null : this.state.user}
                                    email={this.props.isPostLoginVerification ? this.props.loginEmail : null}
                                    userId={this.props.isPostLoginVerification ? this.props.userId : null}
                                    onEmailVerified={this.onEmailVerified.bind(this)}
                                    onUserUpdated={this.onUserUpdated.bind(this)}
                                ></VerifyEmail>;

        const verifyPhonePage = <VerifyPhone
                                    user={(this.props.isPostLoginVerification) ? null : this.state.user}
                                    email={this.props.isPostLoginVerification ? this.props.loginEmail : null}
                                    userId={this.props.isPostLoginVerification ? this.props.userId : null}
                                    phoneNumber={this.props.isPostLoginVerification ? this.props.loginPhone : null}
                                    onPhoneVerified={this.onPhoneVerified.bind(this)}
                                    onUserUpdated={this.onUserUpdated.bind(this)}
                                ></VerifyPhone>;

        let mainView = null;
        switch(this.state.page)
        {
            case PAGE_FORM: mainView = formPage; break;
            case PAGE_VERIFY_EMAIL: mainView = verifyEmailPage; break;
            case PAGE_VERIFY_PHONE: mainView = verifyPhonePage; break;

            default: mainView = formPage; break;
        }

        return(
            <>
                { mainView }
            </>
        );
    }

    closeCard(noConfirmation)
    {
        let message = (this.props.isPostLoginVerification) ?
                        '¿Quieres salir del proceso de verificación?' :
                        '¿Quieres salir del proceso de registro?';

        return (
            <Error text={message} />
        )
    }

    onAccountCreated(user, password)
    {
        let u = { ...user, password: password }

        this.setState({ user: u, password: password, page: PAGE_VERIFY_EMAIL }, () =>
        {

        });
    }
    onEmailVerified(user)
    {
        if (user != null && user.email != null)
        {
            let u = { ...user, password: this.state.password }

            this.setState({ user: u, page: PAGE_VERIFY_PHONE }, () =>
            {

            });
        }
        else
        {
            this.setState({ page: PAGE_VERIFY_PHONE }, () =>
            {

            });
        }
    }
    onPhoneVerified(user)
    {
        let u = { ...user, password: this.state.password }

        if (this.props.setLoginEmail != null &&
            user != null &&
            user.email != null)
        {
            this.props.setLoginEmail(user.email);
        }

        this.setState({ user: u }, () =>
        {
            this.closeCard(true);
        });
    }
    onUserUpdated(user)
    {
        let u = { ...user, password: this.state.password }

        this.setState({ user: u });
    }
}